// extracted by mini-css-extract-plugin
export default {"container":"Z1-z","list":"_1-z"};